import { createFileRoute } from '@tanstack/react-router';

import { GroupsPage } from '@/features/admin/GroupsPage';
import { requireRouteAccess } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/admin/groups')({
  beforeLoad: () => requireRouteAccess('/admin/groups'),
  validateSearch: (search): { subject?: string } => ({
    subject: typeof search.subject === 'string' ? search.subject : undefined,
  }),
  component: GroupsPage,
});
